/**
 * Redirige cuando el hostname es accounts.XXX y falta /accounts en el pathname.
 *
 * - accounts.XXX/<ROUTE>?s=<SUBDOMAIN>&other=1
 *   → <SUBDOMAIN>.XXX/accounts/<ROUTE>?other=1
 *
 * - accounts.XXX/<ROUTE>?other=1
 *   → accounts.XXX/accounts/<ROUTE>?other=1
 */
export function redirectAccounts (): void {
  const { hostname, pathname, search } = window.location

  const match = hostname.match(/^accounts\.(.+)$/)
  if (match == null || pathname.startsWith('/accounts')) return

  const baseDomain = match[1]
  const params = new URLSearchParams(search)
  const subdomain = params.get('s')

  if (subdomain != null) {
    params.delete('s')
  }

  const newHost = subdomain != null ? `${subdomain}.${baseDomain}` : hostname
  const newSearch = params.toString() !== '' ? `?${params.toString()}` : ''

  window.location.replace(`${window.location.protocol}//${newHost}/accounts${pathname}${newSearch}`)
}
